<script>
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import { show_message } from '../../../lib/flash.ts';
  import session from '../../../lib/session';

  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';
  import APIClient from '../../../state-charts/api-client';

  export let order;
  export let order_uuid;
  export let has_inited;
  let dialog;

  const get_merchant_name = () => {
    let merchant = $session.merchant.service.selection_name;
    merchant = merchant
      .toLowerCase()
      .split(' ')
      .join('_');
    return merchant;
  };

  let share_url = encodeURI(
    `${
      location.origin
    }/order/shared/${order_uuid}?merchant=${get_merchant_name()}`
  );
  let share_btns = [
    {
      alt: 'Facebook',
      img: '/assets/material-social-icons/facebook.png',
      href: 'https://facebook.com/sharer/sharer.php?u=' + share_url,
    },
    {
      alt: 'Twitter',
      img: '/assets/material-social-icons/twitter.png',
      href: 'https://twitter.com/share?url=' + share_url,
    },
    {
      alt: 'LinkedIn',
      img: '/assets/material-social-icons/linkedin.png',
      href: 'https://www.linkedin.com/sharing/share-offsite/?url=' + share_url,
    },
    {
      alt: 'Pinterest',
      img: '/assets/material-social-icons/pinterest.png',
      href: 'https://pinterest.com/pin/create/bookmarklet/?&url=' + share_url,
    },
    {
      alt: 'WhatsApp',
      img: '/assets/material-social-icons/whatsapp.png',
      href: 'whatsapp://send?text=' + share_url,
    },
    {
      alt: 'StumbleUpon',
      img: '/assets/material-social-icons/stumbleupon.png',
      href: 'https://stumbleupon.com/submit?url=' + share_url,
    },
    {
      alt: 'Email',
      img: '/assets/material-social-icons/mail.png',
      href: 'mailto:?&body=' + share_url,
    },
  ];

  const init_share = () => {
    dialog = new MDCDialog(document.getElementById(`share-dialog`));
  };

  const copy_to_clipboard = () => {
    var copyText = document.getElementById('myInput');
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand('copy');
    close();
    show_message(t9n(TS.ORDER_COPIED_LINK), 'success');
  };

  export const open = () => dialog.open();

  export const close = () => dialog.close();

  onMount(init_share);
</script>

<div id="share-dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="my-dialog-title">
        {t9n(TS.ORDER_SHARE)}
      </h2>

      <div class="mdc-dialog__content" id="my-dialog-content">
        <input type="text" value={share_url} id="myInput" />
        {#if order && has_inited}
          {#each share_btns as button, i}
            <a href={button.href} target="_blank">
              <img src={button.img} alt={button.alt} width="50" />
            </a>
          {/each}
        {/if}
      </div>

      <footer class="mdc-dialog__actions">
        <!--                {#each buttons as button}-->
        <!--                    <button class="mdc-button mdc-button&#45;&#45;raised {button.classes}"-->
        <!--                            tabindex="0"-->
        <!--                            on:click|preventDefault|stopPropagation={button.action}>-->
        <!--                        {button.label}-->
        <!--                    </button>-->
        <!--                {/each}-->

        <button
          on:click={() => copy_to_clipboard()}
          class="mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          <i class="material-icons">file_copy</i>
          {t9n(TS.TXT_COPY_LINK)}
        </button>

        <button
          on:click={() => close()}
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.LOGIN_FORM_CLOSE)}
        </button>
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
  #share-dialog .mdc-dialog__surface {
    max-width: 450px;
    width: 450px;
  }

  #share-dialog .mdc-dialog__content {
    margin-left: 15px;
  }

  #share-dialog .material-icons {
    margin-left: -5px;
    margin-right: 5px;
  }

  #share-dialog input {
    position: absolute;
    top: -1000px;
    left: -1000px;
  }

  .btn-close {
    margin-left: 5px;
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    #share-dialog .mdc-dialog__surface {
      max-width: min-content;
      width: 100%;
    }
  }

  a:link {
    text-decoration: none;
  }
</style>
